import { FormHelperText } from "@mui/material";

import { Container } from "./FormControllabel.styles";
import { FormControlLabelProps } from "./FormControlLabel.types";
import InputLabel from "../InputLabel";

const FormControlLabel: React.FC<FormControlLabelProps> = ({
  control,
  disabled,
  error,
  helperText,
  label,
  required,
}) => (
  <Container>
    <InputLabel required={required}>{label}</InputLabel>
    {control}
    {helperText ? (
      <FormHelperText disabled={disabled} error={error}>
        {helperText}
      </FormHelperText>
    ) : null}
  </Container>
);

export default FormControlLabel;
